import {post} from "../utils";
import {getStoredUser} from "../authentication/utils";

export default host => (id, token) => post(`${host}${!getStoredUser() ? "/public": ""}/contentCreations/${id}/trackView?token=${token}`)